"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SearchTabsPreview", {
  enumerable: true,
  get: function get() {
    return _SearchTabsPreview.SearchTabsPreview;
  }
});
var _SearchTabsPreview = require("./SearchTabsPreview");